import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index/Index.vue'
import MainContent from './views/Index/MainContent.vue'
import GongSiDongTai from './views/GongSiDongTai/GongSiDongTai.vue'
import GongSiGaiKuang from './views/GongSiGaiKuang/GongSiGaiKuang.vue'
import ZhengCeFaGui from './views/ZhengCeFaGui/ZhengCeFaGui.vue'
import ZCFGDetailInfo from './views/ZhengCeFaGui/ZCFGDetailInfo.vue'
import DetailInfo from './views/GongSiDongTai/DetailInfo.vue'
import ZhaoBiaoDaiLi from './views/ZhaoBiaoDaiLi/ZhaoBiaoDaiLi.vue'
import ZBDLDetailInfo from './views/ZhaoBiaoDaiLi/ZBDLDetailInfo.vue'
import jianDuTouSu from './views/jianDuTouSu/jianDuTouSu.vue'
import LianXiWoMen from './views/LianXiWoMen/LianXiWoMen.vue'
import TongZhiGongGao from './views/TongZhiGongGao/TongZhiGongGao.vue'
import tzDetailInfo from './views/TongZhiGongGao/DetailInfo.vue'

Vue.use(Router)
export default new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/home',
      component: Index,
      children: [
        {
          path: '/home',
          name: 'home',
          component: MainContent
        },
        {
          path: '/gongsigaikuang',
          name: 'gongsigaikuang',
          component: GongSiGaiKuang
        },{
          path: '/GongSiDongTai',
          name: 'GongSiDongTai',
          component: GongSiDongTai
        },{
          path: '/ZhengCeFaGui',
          name: 'ZhengCeFaGui',
          component: ZhengCeFaGui
        },{
          path: '/ZCFGDetailInfo',
          name: 'ZCFGDetailInfo',
          component: ZCFGDetailInfo
        },{
          path: '/DetailInfo',
          name: 'DetailInfo',
          component: DetailInfo
        },{
          path: '/ZhaoBiaoDaiLi',
          name: 'ZhaoBiaoDaiLi',
          component: ZhaoBiaoDaiLi
        },{
          path: '/ZBDLDetailInfo',
          name: 'ZBDLDetailInfo',
          component: ZBDLDetailInfo
        },{
          path: '/jiandutousu',
          name: 'jiandutousu',
          component: jianDuTouSu
        },{
          path: '/LianXiWoMen',
          name: 'LianXiWoMen',
          component: LianXiWoMen
        },{
          path: '/TongZhiGongGao',
          name: 'TongZhiGongGao',
          component: TongZhiGongGao
        },{
          path: '/tzDetailInfo',
          name: 'tzDetailInfo',
          component: tzDetailInfo
        },
      ]
    },
  ]
})
